import React from 'react'
import { combineLatest, of } from 'rxjs'
import { filter, map, switchMap } from 'rxjs/operators'
import { deselectContent, observeSelected } from 'front-end-core/services/StateService'
import url from 'front-end-core/core/url'
import { TAKEOVER_INTERNAL } from 'front-end-core/constants/urls'
import { URL_PDF_LEG } from 'constants/urls'
import { LEGISLATION_REVIEW } from 'constants/controllers'
import SelectedHeader from 'components/shared/SelectedHeader'
import { requestAct } from 'services/LegislationService'
import { shorten } from 'front-end-core/services/ShortenerService'
import { isValidResponse } from 'front-end-core/helpers/dataflow'
import LegislationBreadCrumbsContainer from 'redux/containers/pages/legislation/LegislationBreadCrumbsContainer'

export default (props) => {
  const { aol, act } = props
  const stateSource = act
    ? combineLatest(
      [requestAct({ act, aol }).pipe(filter(isValidResponse), map(a => a.nodes[a.root].leaves)),
        observeSelected('legislation')],
      (leaves, selected) => leaves.filter(leaf => selected[leaf] > 0)
    ).pipe(
      switchMap(
        selectedIds =>
          selectedIds.length
            ? shorten(url(LEGISLATION_REVIEW, { aol, selectedIds })
              .replace(/#/, ''))
              .pipe(map(short => ({ selectedIds, short })))
            : of({ selectedIds: [], short: null })
      )
    )
    : of({ selectedIds: [], short: null })

  return (
    <div>
      <SelectedHeader
        {...props}
        stateSource={stateSource}
        deselectAll={deselectContent.bind(null, 'legislation')}
        keyword={(l) => l === 1 ? 'section' : 'sections'}
        pdfUrl={URL_PDF_LEG}
        dataHelpItem='legislationtoolbar'
        displayPdf={act !== TAKEOVER_INTERNAL}
        displayPrint={act !== TAKEOVER_INTERNAL}
      />
      <LegislationBreadCrumbsContainer />
    </div>
  )
}
